module.exports = __webpack_public_path__ + "static/img/essential4-new.0e3e4c58.png";